import { useTranslation } from "react-i18next";
import { appRouterPaths } from "@/services/navigation";
import type { HeaderNavLink } from "../types";

export const getHeaderNavLinks: () => HeaderNavLink[] = () => {
  const { t } = useTranslation();

  return [
    {
      title: t("common.dashboard"),
      path: appRouterPaths.dashboards,
    },
    {
      title: t("common.contacts"),
      path: appRouterPaths.contacts.base,
    },
    {
      title: t("common.noteType.commitment", { count: 2 }),
      path: appRouterPaths.commitments,
    },
    {
      title: t("common.noteType.note", { count: 2 }),
      path: appRouterPaths.notes,
    },
    {
      title: t("common.noteType.idea", { count: 2 }),
      path: appRouterPaths.ideas,
    },
    {
      title: t("common.calendar"),
      path: appRouterPaths.calendarV2,
    },
  ];
};
